export default "__VITE_ASSET__qCVvcTWl__"